import { HTMLAttributes } from 'react';
import { UploadedFile } from '../../ui';
import { twMerge } from 'tailwind-merge';

type Props = {
  files: Array<File>;
  onDelete: (file: File) => void;
} & Omit<HTMLAttributes<HTMLDivElement>, 'children'>;

export function RichTextEditorFileList(props: Props) {
  const { files, onDelete, className, ...rest } = props;

  return (
    <div className={twMerge('relative', className)} {...rest}>
      <div className="flex flex-row items-center gap-x-8 pr-32">
        {files.map((file, key) => (
          <UploadedFile
            key={`uploaded-file-${key}`}
            name={file.name}
            mimetype={file.type}
            action="delete"
            onDelete={() => onDelete(file)}
            className="text-nowrap"
          />
        ))}
      </div>
    </div>
  );
}
